// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"barcode"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.75 3L7.75 20M16.25 3L16.25 20M3 3H4V20H3V3ZM11.5 3H12.5V20H11.5V3ZM20 3H21V20H20V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BarcodeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'barcode',
    ref,
    icon: element,
  },
));

BarcodeIcon.displayName = 'BarcodeIcon';

export default BarcodeIcon;
